import '.em{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.en{padding-left:1.5rem;}.ssr-plugin'
import '.eo{margin:1rem 0;}.ssr-plugin'
import '.ep{color:var(--gray-700);}.ssr-plugin'
import '.eq{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="em en eo ep eq"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
